/**
 *
 * @param {string} name
 * @returns
 */

import key from "./key"

const url = `app/${key}`

export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`

export const LOAD_DATA_COPY = `${url}/LOAD_DATA_COPY`
export const LOAD_DATA_COPY_SUCCESS = `${url}/LOAD_DATA_COPY_SUCCESS`
export const LOAD_DATA_COPY_ERROR = `${url}/LOAD_DATA_COPY_ERROR`

//Data Scheduling section
export const LOAD_DATA_SCHEDULING = `${url}/LOAD_DATA_SCHEDULING`
export const LOAD_DATA_SCHEDULING_SUCCESS = `${url}/LOAD_DATA_SCHEDULING_SUCCESS`
export const LOAD_DATA_SCHEDULING_ERROR = `${url}/LOAD_DATA_SCHEDULING _ERROR`


export const ADD_DATA_SCHEDULING = `${url}/ADD_DATA_SCHEDULING`
export const ADD_DATA_SCHEDULING_SUCCESS = `${url}/ADD_DATA_SCHEDULING_SUCCESS`
export const ADD_DATA_SCHEDULING_ERROR = `${url}/ADD_DATA_SCHEDULING_ERROR`

export const LOAD_DATA_SCHEDULING_SERVICE = `${url}/LOAD_DATA_SCHEDULING_SERVICE`
export const LOAD_DATA_SCHEDULING_SERVICE_SUCCESS = `${url}/LOAD_DATA_SCHEDULING_SERVICE_SUCCESS`
export const LOAD_DATA_SCHEDULING_SERVICE_ERROR = `${url}/LOAD_DATA_SCHEDULING_SERVICE_ERROR`

export const REMOVE_DATA_SERVICE = `${url}/REMOVE_DATA_SERVICE`
export const REMOVE_DATA_SERVICE_SUCCESS = `${url}/REMOVE_DATA_SERVICE_SUCCESS`
export const REMOVE_DATA_SERVICE_ERROR = `${url}/REMOVE_DATA_SERVICE_ERROR`

export const UPDATE_DATA_SCHEDULING = `${url}/UPDATE_DATA_SCHEDULING`
export const UPDATE_DATA_SCHEDULING_SUCCESS = `${url}/UPDATE_DATA_SCHEDULING_SUCCESS`
export const UPDATE_DATA_SCHEDULING_ERROR = `${url}/UPDATE_DATA_SCHEDULING_ERROR`

export const SHOOTER_HISTORY_LIST = `${url}/SHOOTER_HISTORY_LIST`
export const SHOOTER_HISTORY_LIST_SUCCESS = `${url}/SHOOTER_HISTORY_LIST_SUCCESS`
export const SHOOTER_HISTORY_LIST_ERROR = `${url}/SHOOTER_HISTORY_LIST_ERROR`

export const DATA_FINAL_COMMIT = `${url}/DATA_FINAL_COMMIT`
export const DATA_FINAL_COMMIT_SUCCESS = `${url}/DATA_FINAL_COMMIT_SUCCESS`
export const DATA_FINAL_COMMIT_ERROR = `${url}/DATA_FINAL_COMMIT_ERROR`

export const AGENT_VANCANY_LIST = `${url}/AGENT_VANCANY_LIST`
export const AGENT_VANCANY_LIST_SUCCESS = `${url}/AGENT_VANCANY_LIST_SUCCESS`
export const AGENT_VANCANY_LIST_ERROR = `${url}/AGENT_VANCANY_LIST_ERROR`

export const AGENT_OFFICE_VACANCY_LIST = `${url}/AGENT_OFFICE_VACANCY_LIST`
export const AGENT_OFFICE_VACANCY_LIST_SUCCESS = `${url}/AGENT_OFFICE_VACANCY_LIST_SUCCESS`
export const AGENT_OFFICE_VACANCY_LIST_ERROR = `${url}/AGENT_OFFICE_VACANCY_LIST_ERROR`

//NAS Link

export const LOAD_NAS_LINK_DETAILS = `${url}/LOAD_NAS_LINK_DETAILS`
export const LOAD_NAS_LINK_DETAILS_SUCCESS = `${url}/LOAD_NAS_LINK_DETAILS_SUCCESS`
export const LOAD_NAS_LINK_DETAILS_ERROR = `${url}/ LOAD_NAS_LINK_DETAILS_ERROR`
export const ADD_NAS_LINK = `${url}/ADD_NAS_LINK`
export const ADD_NAS_LINK_SUCCESS = `${url}/ADD_NAS_LINK_SUCCESS`
export const ADD_NAS_LINK_ERROR = `${url}/ ADD_NAS_LINK_ERROR`

export const UPDATE_NAS_LINK = `${url}/UPDATE_NAS_LINK`
export const UPDATE_NAS_LINK_SUCCESS = `${url}/UPDATE_NAS_LINK_SUCCESS`
export const UPDATE_NAS_LINK_ERROR = `${url}/ UPDATE_NAS_LINK_ERROR`

export const DELETE_NAS_LINK = `${url}/DELETE_NAS_LINK`
export const DELETE_NAS_LINK_SUCCESS = `${url}/DELETE_NAS_LINK_SUCCESS`
export const DELETE_NAS_LINK_ERROR = `${url}/DELETE_NAS_LINK_ERROR`

//Data Link

export const LOAD_DATA_LINK_DETAILS = `${url}/LOAD_DATA_LINK_DETAILS`
export const LOAD_DATA_LINK_DETAILS_SUCCESS = `${url}/LOAD_DATA_LINK_DETAILS_SUCCESS`
export const LOAD_DATA_LINK_DETAILS_ERROR = `${url}/ LOAD_DATA_LINK_DETAILS_ERROR`
export const ADD_DATA_LINK = `${url}/ADD_DATA_LINK`
export const ADD_DATA_LINK_SUCCESS = `${url}/ADD_DATA_LINK_SUCCESS`
export const ADD_DATA_LINK_ERROR = `${url}/ ADD_DATA_LINK_ERROR`

export const UPDATE_DATA_LINK = `${url}/UPDATE_DATA_LINK`
export const UPDATE_DATA_LINK_SUCCESS = `${url}/UPDATE_DATA_LINK_SUCCESS`
export const UPDATE_DATA_LINK_ERROR = `${url}/ UPDATE_DATA_LINK_ERROR`

export const DELETE_DATA_LINK = `${url}/DELETE_DATA_LINK`
export const DELETE_DATA_LINK_SUCCESS = `${url}/DELETE_DATA_LINK_SUCCESS`
export const DELETE_DATA_LINK_ERROR = `${url}/DELETE_DATA_LINK_ERROR`

export const LOAD_SERVICE_LEVEL = `${url}/LOAD_SERVICE_LEVEL`
export const LOAD_SERVICE_LEVEL_SUCCESS = `${url}/LOAD_SERVICE_LEVEL_SUCCESS`
export const LOAD_SERVICE_LEVEL_ERROR = `${url}/ LOAD_SERVICE_LEVEL_ERROR`

export const UPLOAD_QC = `${url}/UPLOAD_QC`
export const UPLOAD_QC_SUCCESS = `${url}/UPLOAD_QC_SUCCESS`
export const UPLOAD_QC_ERROR = `${url}/UPLOAD_QC_ERROR`

export const UPDATE_NAS_COMMIT = `${url}/UPDATE_NAS_COMMIT`
export const UPDATE_NAS_COMMIT_SUCCESS = `${url}/UPDATE_NAS_COMMIT_SUCCESS`
export const UPDATE_NAS_COMMIT_ERROR = `${url}/UPDATE_NAS_COMMIT_ERROR`

export const LOAD_PENDING_STATUS = `${url}/LOAD_PENDING_STATUS`
export const LOAD_PENDING_STATUS_SUCCESS = `${url}/LOAD_PENDING_STATUS_SUCCESS`
export const LOAD_PENDING_STATUS_ERROR = `${url}/ LOAD_PENDING_STATUS_ERROR`

export const UPDATE_DATA_COPY = `${url}/UPDATE_DATA_COPY`
export const UPDATE_DATA_COPY_SUCCESS = `${url}/UPDATE_DATA_COPY_SUCCESS`
export const UPDATE_DATA_COPY_ERROR = `${url}/ UPDATE_DATA_COPY_ERROR`

export const UPDATE_EXPAND = `${url}/UPDATE_EXPAND`
export const UPDATE_EXPAND_SUCCESS = `${url}/UPDATE_EXPAND_SUCCESS`
export const UPDATE_EXPAND_ERROR = `${url}/ UPDATE_EXPAND_ERROR`
//LOAD_DATA_DETAILS
export const LOAD_DATA_DETAILS = `${url}/LOAD_DATA_DETAILS`
export const LOAD_DATA_DETAILS_SUCCESS = `${url}/LOAD_DATA_DETAILS_SUCCESS`
export const LOAD_DATA_DETAILS_ERROR = `${url}/LOAD_DATA_DETAILS_ERROR`
//
export const LOAD_EXPAND_DATA = `${url}/LOAD_EXPAND_DATA`
export const LOAD_EXPAND_DATA_SUCCESS = `${url}/LOAD_EXPAND_DATA_SUCCESS`
export const LOAD_EXPAND_DATA_ERROR = `${url}/ LOAD_EXPAND_DATA_ERROR`
const constants = {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_DATA_COPY,
  LOAD_DATA_COPY_SUCCESS,
  LOAD_DATA_COPY_ERROR,

  //Data scheduling client details
  ADD_DATA_SCHEDULING,
  ADD_DATA_SCHEDULING_SUCCESS,
  ADD_DATA_SCHEDULING_ERROR,

  REMOVE_DATA_SERVICE,
  REMOVE_DATA_SERVICE_SUCCESS,
  REMOVE_DATA_SERVICE_ERROR,

  LOAD_DATA_SCHEDULING_SERVICE,
  LOAD_DATA_SCHEDULING_SERVICE_SUCCESS,
  LOAD_DATA_SCHEDULING_SERVICE_ERROR,

  LOAD_DATA_SCHEDULING_SUCCESS,
  LOAD_DATA_SCHEDULING_ERROR,
  LOAD_DATA_SCHEDULING,

  UPDATE_DATA_SCHEDULING,
  UPDATE_DATA_SCHEDULING_SUCCESS,
  UPDATE_DATA_SCHEDULING_ERROR,

  SHOOTER_HISTORY_LIST,
  SHOOTER_HISTORY_LIST_SUCCESS,
  SHOOTER_HISTORY_LIST_ERROR,

  DATA_FINAL_COMMIT,
  DATA_FINAL_COMMIT_SUCCESS,
  DATA_FINAL_COMMIT_ERROR,

  AGENT_VANCANY_LIST,
  AGENT_VANCANY_LIST_SUCCESS,
  AGENT_VANCANY_LIST_ERROR,

  AGENT_OFFICE_VACANCY_LIST,
  AGENT_OFFICE_VACANCY_LIST_SUCCESS,
  AGENT_OFFICE_VACANCY_LIST_ERROR,

  //Nas link

  ADD_NAS_LINK,
  ADD_NAS_LINK_SUCCESS,
  ADD_NAS_LINK_ERROR,

  UPDATE_NAS_LINK,
  UPDATE_NAS_LINK_SUCCESS,
  UPDATE_NAS_LINK_ERROR,

  LOAD_NAS_LINK_DETAILS,
  LOAD_NAS_LINK_DETAILS_SUCCESS,
  LOAD_NAS_LINK_DETAILS_ERROR,

  DELETE_NAS_LINK,
  DELETE_NAS_LINK_SUCCESS,
  DELETE_NAS_LINK_ERROR,

  //Data link

  ADD_DATA_LINK,
  ADD_DATA_LINK_SUCCESS,
  ADD_DATA_LINK_ERROR,

  UPDATE_DATA_LINK,
  UPDATE_DATA_LINK_SUCCESS,
  UPDATE_DATA_LINK_ERROR,

  LOAD_DATA_LINK_DETAILS,
  LOAD_DATA_LINK_DETAILS_SUCCESS,
  LOAD_DATA_LINK_DETAILS_ERROR,

  DELETE_DATA_LINK,
  DELETE_DATA_LINK_SUCCESS,
  DELETE_DATA_LINK_ERROR,

  LOAD_SERVICE_LEVEL,
  LOAD_SERVICE_LEVEL_SUCCESS,
  LOAD_SERVICE_LEVEL_ERROR,

  UPLOAD_QC,
  UPLOAD_QC_SUCCESS,
  UPLOAD_QC_ERROR,

  UPDATE_NAS_COMMIT,
  UPDATE_NAS_COMMIT_SUCCESS,
  UPDATE_NAS_COMMIT_ERROR, 

  LOAD_PENDING_STATUS,
  LOAD_PENDING_STATUS_SUCCESS,
  LOAD_PENDING_STATUS_ERROR,

  UPDATE_DATA_COPY,
  UPDATE_DATA_COPY_SUCCESS,
  UPDATE_DATA_COPY_ERROR,

  UPDATE_EXPAND,
  UPDATE_EXPAND_SUCCESS,
  UPDATE_EXPAND_ERROR,

  LOAD_DATA_DETAILS,
  LOAD_DATA_DETAILS_SUCCESS,
  LOAD_DATA_DETAILS_ERROR,

  LOAD_EXPAND_DATA,
  LOAD_EXPAND_DATA_SUCCESS,
  LOAD_EXPAND_DATA_ERROR
}

export default constants
